import { LeftOutlined } from "@ant-design/icons";

const BackButton = ({
  onBackPress = () => {},
  customBackButtonStyle = "",
  children = undefined,
}) => {
  return children ? (
    children
  ) : (
    <LeftOutlined
      onClick={onBackPress}
      style={{ color: "var(--color-login-back-button)" }}
      className={customBackButtonStyle}
    />
  );
};

export default BackButton;
